const taskSteps = [
  {
    target: "#active",
    title: "Active Tasks",
    content:
      "ဒီနေရာမှာ သင်၏ လက်ရှိ လုပ်ဆောင်နိုင်သော Task များကို ကြည့်ရှုနိုင်ပါသည်။",
  },
  {
    target: "#daily",
    title: "Daily Tasks",
    content:
      "ဒီနေရာမှာ နေ့စဉ် လုပ်ဆောင်ရမည့် Task များကို လုပ်ဆောင်နိုင်ပြီး Gem များ နေ့တိုင်း စုဆောင်းနိုင်ပါသည်။",
  },
  {
    target: "#completed",
    title: "Completed Tasks",
    content: "ဒီနေရာမှာ သင်၏ လုပ်ဆောင်ပြီးသော Task များကို ကြည့်ရှုနိုင်ပါသည်။",
  },
  {
    target: ".pendingTasks",
    title: "Pending Tasks",
    content:
      "ဒီနေရာမှာ လုပ်ဆောင်ထားပြီး Admin မှ အတည်ပြုရန် လိုအပ်သော Task များကို ကြည့်ရှုနိုင်ပါသည်။",
  },
  {
    target: ".restartTour",
    title: "Restart Tour",
    content: "ပြန်ကြည့်ချင်ရင် ဒီနေရာကို နှိပ်ပါ။",
  },
];

export default taskSteps;

export const homeSteps = [
  {
    target: ".yourGems",
    title: "Your Gems",
    content:
      "သင်ရရှိထားသော Gem များကို ဒီနေရာတွင် ကြည့်ရှုနိုင်ပါသည်။ Gem များကို Task များကို လုပ်ဆောင်ခြင်းဖြင့် ရရှိနိုင်ပြီး Star ဖြင့်လည်း ဝယ်ယူနိုင်ပါသည်။",
  },
  {
    target: ".yourTickets",
    title: "Your Tickets",
    content:
      "သင်ရရှိထားသော Ticket များကို ဒီနေရာတွင် ကြည့်ရှုနိုင်ပါသည်။ Ticket များကို Task များကို လုပ်ဆောင်ခြင်းဖြင့် ရရှိနိုင်ပြီး Star ဖြင့်လည်း ဝယ်ယူနိုင်ပါသည်။",
  },
  {
    target: ".tasksTab",
    title: "Tasks List",
    content: "ဒီနေရာမှာ Task များကို ကြည့်ရှုနိုင်ပြီး လုပ်ဆောင်နိုင်ပါသည်။",
  },
  {
    target: ".storeTab",
    title: "Store",
    content: "ဒီနေရာမှာ Gem နှင့် Ticket များကို star ဖြင့် ဝယ်ယူနိုင်ပါသည်။",
  },
  {
    target: ".gameTab",
    title: "Games",
    content: "ဒီနေရာမှာ Lucky Spin လှည့်ပြီး Gem များ ရရှိနိုင်ပါသည်။",
  },
  {
    target: ".profileTab",
    title: "Profile",
    content:
      "ဒီနေရာမှာ သင်၏ Profile နှင့် Referral Link ကို ကြည့်ရှုနိုင်ပြီး မိတ်ဆွေများကို ဖိတ်ခေါ်နိုင်ပါသည်။",
  },
  {
    target: "#channels",
    title: "Movies",
    content: "ဒီနေရာမှာ Movies စာရင်းကို ကြည့်ရှုနိုင်ပါသည်။",
  },
  {
    target: ".filter-free",
    title: "Free Channels",
    content: "အခမဲ့ ကြည့်ရှုနိုင်သော Channel များကို ဒီနေရာမှာ ရွေးချယ်ကြည့်ရှုနိုင်ပါသည်။",
  },
  {
    target: ".filter-gems",
    title: "Gems Channels",
    content: "Gem ဖြင့် ဝင်ရောက်ကြည့်ရှုနိုင်သော Channel များကို ဒီနေရာမှာ ရွေးချယ်ကြည့်ရှုနိုင်ပါသည်။",
  },
  {
    target: ".filter-paid",
    title: "Paid Channels",
    content: "Star (သို့) TON ဖြင့် ဝယ်ယူကြည့်ရှုနိုင်သော Premium Channel များကို ဒီနေရာမှာ ရွေးချယ်ကြည့်ရှုနိုင်ပါသည်။",
  },
  {
    target: ".buyButtons",
    title: "Invite Links ယူရန်",
    content: "Invite Links များကို ဒီမှာ ရယူနိုင်ပါတယ်။",
  },
  {
    target: "#invites",
    title: "Invite Links",
    content:
      "ဒီနေရာမှာ Generate လုပ်ထားသော Invite Links များကို ကြည့်ရှုနိုင်ပါသည်။ Invite Link များကို ၁ နာရီအတွင်း အသုံးပြုရမည်။",
  },
  {
    target: ".restartTour",
    title: "Restart Tour",
    content: "ပြန်ကြည့်ချင်ရင် ဒီနေရာကို နှိပ်ပါ။",
  },
];